import { TFunction } from "i18next";
import { AuthError } from "./auth-error";
import { AuthSession, isSessionExpired } from "./auth-session";

/** Текст ошибки входа для пользователя. */
export const getAuthErrorMessage = (
  t: TFunction,
  error: AuthError,
  session?: AuthSession | null,
): string => {
  switch (error.code) {
    case "INVALID_CODE":
      return t("auth.errors.invalid_code");
    case "SESSION_CLOSED":
      return t("auth.errors.session_closed");
    case "INVALID_SESSION":
      return t("auth.errors.session_expired");
    case "EXPIRED":
      return !session || isSessionExpired(session)
        ? t("auth.errors.session_expired")
        : t("auth.errors.code_expired");
    case "CHANNEL_UNAVAILABLE":
      return t("auth.errors.channel_unavailable");
    case "SEND_COOLDOWN":
      return t("auth.errors.send_cooldown");
    case "RATE_LIMIT_EXCEEDED":
      return t("auth.errors.rate_limit");
    case "NETWORK":
      return t("auth.errors.network");
    case "VALIDATION_ERROR":
      return error.description || t("auth.errors.validation");
    default:
      return error.description || t("auth.errors.unknown");
  }
};
